
export class Filter {
  field: string;
  value: string; 
  constructor(field: string, value: string){
    this.field = field;
    this.value = value;
  }
}
